
import CallSlash from "../../../assets/outline/CallSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CallSlashIcon({ className, dataTestid = "CallSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CallSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
